import { render, staticRenderFns } from "./WordertailDetails.vue?vue&type=template&id=7927b89c&scoped=true"
import script from "./WordertailDetails.vue?vue&type=script&lang=js"
export * from "./WordertailDetails.vue?vue&type=script&lang=js"
import style0 from "./WordertailDetails.vue?vue&type=style&index=0&id=7927b89c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7927b89c",
  null
  
)

export default component.exports